import { motion } from "framer-motion";
import { cn } from "../utils/cn";
import type { ContainerProps } from "./types";

export const FadeInUpContainer = ({ children, className, ...props }: ContainerProps) => (
  <motion.div
    {...props}
    initial={{ y: 12 }}
    animate={{ y: 0 }}
    transition={{ duration: 0.2 }}
    className={cn(
      "mx-auto px-5 pb-safe-offset-5 md:pb-safe-offset-12 w-full max-w-screen-xl",
      className
    )}
  >
    {children}
  </motion.div>
);

FadeInUpContainer.displayName = "FadeInUpContainer";
